// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__QfNLi {
    align-items: center;
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 0.75rem 1rem;
}

/* Layout: esquerda (itens por página) | centro (resultados) | direita (navegação) */
.styles_pagination__sVsE4 {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    justify-content: space-between;
    width: 100%;
}

.styles_rowPerPage__HaO-G {
    align-items: center;
    display: flex;
    flex-shrink: 0;
    gap: 0.5rem;
}

.styles_label__wC7II {
    color: rgba(0, 0, 0, 0.7);
    font-size: 0.875rem;
    white-space: nowrap;
}

.styles_select__uuL2i {
    border: 1px solid rgba(0, 0, 0, 0.23);
    border-radius: 4px;
    padding: 0.4rem 2rem 0.4rem 0.5rem;
    font-size: 0.875rem;
    background-color: #fff;
    cursor: pointer;
    min-width: 4rem;
}

.styles_select__uuL2i:hover {
    border-color: rgba(0, 0, 0, 0.4);
}

.styles_select__uuL2i:focus {
    outline: none;
    border-color: #18316e;
}

.styles_summary__LROco {
    color: rgba(0, 0, 0, 0.7);
    flex: 1 1;
    font-size: 0.875rem;
    min-width: 0;
    text-align: center;
}

.styles_nav__aQVmt,
.styles_pages__v1FuB {
    align-items: center;
    display: flex;
    flex-shrink: 0;
    gap: 0.25rem;
}

.styles_button__8d30x {
    align-items: center;
    background: transparent;
    border: 1px solid rgba(0, 0, 0, 0.23);
    border-radius: 4px;
    color: #18316e;
    cursor: pointer;
    display: flex;
    justify-content: center;
    padding: 0.4rem;
    min-width: 32px;
}

.styles_button__8d30x:hover:not(:disabled) {
    background: rgba(24, 49, 110, 0.08);
    border-color: #18316e;
}

.styles_disabled__7g0GO {
    align-items: center;
    background: transparent;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    color: rgba(0, 0, 0, 0.26);
    cursor: not-allowed;
    display: flex;
    justify-content: center;
    padding: 0.4rem;
    min-width: 32px;
}

.styles_pageCurrent__LwI5f {
    align-items: center;
    background: #18316e;
    border-radius: 4px;
    color: #fff;
    display: inline-flex;
    font-size: 0.875rem;
    font-weight: 500;
    justify-content: center;
    min-width: 32px;
    padding: 0.4rem 0.5rem;
}

@media (max-width: 600px) {
    .styles_pagination__sVsE4 {
        flex-direction: column;
        align-items: stretch;
        gap: 0.75rem;
    }

    .styles_rowPerPage__HaO-G {
        justify-content: center;
    }

    .styles_nav__aQVmt {
        justify-content: center;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pagination/styles.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,qBAAqB;AACzB;;AAEA,oFAAoF;AACpF;IACI,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,SAAS;IACT,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,kCAAkC;IAClC,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,SAAO;IACP,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;IAEI,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,mCAAmC;IACnC,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,kBAAkB;IAClB,0BAA0B;IAC1B,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI;QACI,sBAAsB;QACtB,oBAAoB;QACpB,YAAY;IAChB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;AACJ","sourcesContent":[".container {\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    padding: 0.75rem 1rem;\n}\n\n/* Layout: esquerda (itens por página) | centro (resultados) | direita (navegação) */\n.pagination {\n    align-items: center;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1rem;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.rowPerPage {\n    align-items: center;\n    display: flex;\n    flex-shrink: 0;\n    gap: 0.5rem;\n}\n\n.label {\n    color: rgba(0, 0, 0, 0.7);\n    font-size: 0.875rem;\n    white-space: nowrap;\n}\n\n.select {\n    border: 1px solid rgba(0, 0, 0, 0.23);\n    border-radius: 4px;\n    padding: 0.4rem 2rem 0.4rem 0.5rem;\n    font-size: 0.875rem;\n    background-color: #fff;\n    cursor: pointer;\n    min-width: 4rem;\n}\n\n.select:hover {\n    border-color: rgba(0, 0, 0, 0.4);\n}\n\n.select:focus {\n    outline: none;\n    border-color: #18316e;\n}\n\n.summary {\n    color: rgba(0, 0, 0, 0.7);\n    flex: 1;\n    font-size: 0.875rem;\n    min-width: 0;\n    text-align: center;\n}\n\n.nav,\n.pages {\n    align-items: center;\n    display: flex;\n    flex-shrink: 0;\n    gap: 0.25rem;\n}\n\n.button {\n    align-items: center;\n    background: transparent;\n    border: 1px solid rgba(0, 0, 0, 0.23);\n    border-radius: 4px;\n    color: #18316e;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    padding: 0.4rem;\n    min-width: 32px;\n}\n\n.button:hover:not(:disabled) {\n    background: rgba(24, 49, 110, 0.08);\n    border-color: #18316e;\n}\n\n.disabled {\n    align-items: center;\n    background: transparent;\n    border: 1px solid rgba(0, 0, 0, 0.12);\n    border-radius: 4px;\n    color: rgba(0, 0, 0, 0.26);\n    cursor: not-allowed;\n    display: flex;\n    justify-content: center;\n    padding: 0.4rem;\n    min-width: 32px;\n}\n\n.pageCurrent {\n    align-items: center;\n    background: #18316e;\n    border-radius: 4px;\n    color: #fff;\n    display: inline-flex;\n    font-size: 0.875rem;\n    font-weight: 500;\n    justify-content: center;\n    min-width: 32px;\n    padding: 0.4rem 0.5rem;\n}\n\n@media (max-width: 600px) {\n    .pagination {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 0.75rem;\n    }\n\n    .rowPerPage {\n        justify-content: center;\n    }\n\n    .nav {\n        justify-content: center;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__QfNLi`,
	"pagination": `styles_pagination__sVsE4`,
	"rowPerPage": `styles_rowPerPage__HaO-G`,
	"label": `styles_label__wC7II`,
	"select": `styles_select__uuL2i`,
	"summary": `styles_summary__LROco`,
	"nav": `styles_nav__aQVmt`,
	"pages": `styles_pages__v1FuB`,
	"button": `styles_button__8d30x`,
	"disabled": `styles_disabled__7g0GO`,
	"pageCurrent": `styles_pageCurrent__LwI5f`
};
export default ___CSS_LOADER_EXPORT___;
